import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { HistoryService } from '../../services/history.service';

@Component({
  selector: 'app-order-story-dialog',
  templateUrl: './order-story-dialog.component.html',
  styleUrls: ['./order-story-dialog.component.scss']
})
export class OrderStoryDialogComponent implements OnInit {

  history = [];

  constructor(public dialogRef: MatDialogRef<OrderStoryDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private hist: HistoryService) { }

  ngOnInit() {
    this.hist.getHistoryOrder({ 'id': this.data.order_id }).subscribe(obj => {
      this.history = obj['data'].map(item => {
        if (item.created_at) {
          item.created_at = new Date(Date.parse(item.created_at) - +localStorage.getItem('timezones')[item.service_id] * 1000);
        }
        return item;
      }).sort((a, b) => {
        return +new Date(a.created_at) - +new Date(b.created_at);
      });
    });
  }

  shouCauser(id, i) {
    this.hist.getHistoryCauser({
      'id': id
    }).subscribe(obj => {
      this.history[i].causer = obj['data'];
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/order-story-dialog/order-story-dialog.component.ts